import { useContext, useEffect, useState } from 'react';
import { EditContext } from '../context/EditContext';

export function useTestimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { configVersion } = useContext(EditContext);
  useEffect(() => {
    let ok = true;
    fetch('/api/testimonials')
      .then((r) => r.json())
      .then((d) => { if (ok) { setItems(d.items || []); setLoading(false); } })
      .catch(() => { if (ok) { setItems([]); setLoading(false); } });
    return () => { ok = false; };
  }, [configVersion]);
  return { items, loading };
}
